export default "__VITE_ASSET__CpH1Ep65__"